import $ from "cash-dom";
export { Toast, Modal, Dropdown, Tooltip, Popover } from "bootstrap";
window.$ = $;
export default $;
